import { Flex } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";
import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: fit-content;
  padding: 0;
  padding-bottom: 1em;
  border-radius: 12px;
  background-color: #ffffff;
  border: 1px solid #e7e7f0;
  padding-bottom: 0px;
  transition: all 0.3s cubic-bezier(0.4, 0, 1, 1) 0s;
  ${(props: any) => props.styles};

  overflow: hidden;
  @media (min-width: 768px) {
    padding-left: 0;
    padding-bottom: 0;
    padding-top: 0;
    ${(props: any) => props.styles}
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  font-weight: bold;
  cursor: pointer;
  padding: 8px 0;
  margin-top: 8px;
`;

export const DropdownContainer = styled.div<{ expanded: boolean }>`
  overflow: hidden;
  max-height: ${(props) => (props.expanded ? "500px" : "0px")};
  opacity: ${(props) => (props.expanded ? 1 : 0)};
  transition:
    all 150ms cubic-bezier(0.4, 0, 0.2, 1),
    max-height 300ms cubic-bezier(0.4, 0, 0.2, 1),
    opacity 300ms cubic-bezier(0.4, 0, 0.2, 1);
`;

export const TotalSection = styled(Flex)`
  font-weight: bold;
  flex-direction: column;
  gap: 12px;
  margin-top: 12px;
`;

export const GSTText = styled.div`
  font-size: 14px;
  color: gray;
  margin-top: 12px;
`;

export const FinalTotal = styled.div`
  font-size: 18px;
  color: #451999;
  font-weight: 600;
`;

export const CoverItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 20px;
  flex-direction: column;
`;

export const CardBodyContainer = styled.div`
  padding: 24px 16px;
`;

export const IDVSection = styled(Flex)`
  flex-direction: column;
`;

export const IDVHeadingWrapper = styled(Flex)`
  justify-content: space-between;
`;

export const IDVHeading = styled(Text)`
  color: #5b5675;
  font-family: "Euclid Circular B";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const IDVSectionHeading = styled(IDVHeading)`
  font-weight: 500;
  display: inline-block; 
  max-width: fit-content;
  @media (min-width: 768px) {
    max-width: unset;
  }

`;

export const Price = styled.span`
  color: #040222;
  font-family: "Euclid Circular B";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`;

export const SectionHeaderPrice = styled(SectionHeader)`
  margin: 0px;
  padding: 0px;
  align-items: center;
  width: auto;
`;
